<mat-sidenav-container hasBackdrop class="main-container">
    <mat-sidenav #sidenav mode="push" [(opened)]="chatService.isOpened">
        <ng-content select=".sidenav"></ng-content>
    </mat-sidenav>

    <mat-sidenav-content>
        <section class="full-height rows p-s">
            <div class="d-flex header">
                <button mat-icon-button  (click)="toggleMenu(); sidenav.toggle()">
                    <mat-icon aria-hidden="false" aria-label="Menu" fontIcon="menu" />
                </button>
                <h4 class="text-center flex-1 mt-xs mb-xs">
                  Fyxt Assist
                  <span class="beta-tag">Beta</span>
                </h4>
                <button mat-icon-button (click)="createNewChat()"><mat-icon>add</mat-icon></button>
            </div>
            <ng-content></ng-content>
        </section>
    </mat-sidenav-content>
</mat-sidenav-container>
